import { Box, Paper, Skeleton, Typography, Divider, FormControlLabel, Checkbox, Grid, FormGroup, Stack, Alert, Button, CircularProgress } from "@mui/material";

const RolesSkeleton = () => {
    return (
        <Paper elevation={2} sx={{ padding: 3, mt: 2, borderRadius: 2 }}>
            <Skeleton variant="rectangular" width="100%" height={56} sx={{ mb: 2 }} />

            <Box sx={{ mt: 1, mb: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <Skeleton variant="text" width={150} height={30} />
                <Skeleton variant="rectangular" width={50} height={30} />
            </Box>

            <Divider />

            <Box>
                {[1, 2, 3].map((_, index) => (
                    <Box key={index} sx={{ py: 1, borderBottom: '1px solid #e0e0e0' }}>
                        <Grid container alignItems="center">
                            <Grid size={{ xs: 12, sm: 4 }}>
                                <Skeleton variant="text" width={120} height={25} />
                            </Grid>
                            <Grid size={{ xs: 12, sm: 8 }} style={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <FormGroup row>
                                    {[1, 2, 3].map((__, idx) => (
                                        <FormControlLabel
                                            key={idx}
                                            control={<Skeleton variant="rectangular" width={30} height={30} />}
                                            label={<Skeleton variant="text" width={50} height={25} />}
                                        />
                                    ))}
                                </FormGroup>
                            </Grid>
                        </Grid>
                    </Box>
                ))}
            </Box>

            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} sx={{ mt: 3, mb: 2, width: '100%', justifyContent: 'center', alignItems: 'center' }}>
                <Alert severity="error" sx={{ flex: 1, visibility: 'hidden' }}>
                    Placeholder error message
                </Alert>
                <Box sx={{ display: 'flex', gap: 2, flexDirection: { xs: 'column', sm: 'row' }, minWidth: { xs: '100%', sm: 'auto' } }}>
                    <Skeleton variant="rectangular" width={120} height={38} />
                    <Skeleton variant="rectangular" width={120} height={38} />
                </Box>
            </Stack>
        </Paper>
    );
};

export default RolesSkeleton;